<template>
  <Modal>
    <b-modal
      id="appointments-patient-modal"
      size="xl"
      centered
      no-close-on-backdrop
      no-close-on-esc
      @show="init"
      @hidden="reset"
      @ok="confirm"
    >
      <template #modal-header="{ close }">
        <h1>
          {{ $t('patients.edit') }}
        </h1>
        <button
          type="button"
          class="close"
          :disabled="savingPatient || disableComponents"
          @click="close()"
        >
          ×
        </button>
      </template>
      <Skeleton
        v-if="loadingPatient"
        :title="false"
        :buttons="0"
        :rows="11"
        :columns="3"
        :small="false"
      />
      <b-form v-else>
        <input id="patient-id" type="hidden" v-model="patient.id" />
        <b-form-group
          v-for="group in patient_model.fields.form"
          :key="group.groupName"
        >
          <legend v-if="group.groupName">{{ group.groupName }}</legend>
          <div
            class="form-fields"
            :class="group.type"
            :style="`grid-template-columns: ${group.gridTemplateColumns}`"
          >
            <FormField
              v-for="field in group.fields"
              :key="field.key"
              entity-name="patient"
              entity-state="patient"
              :field="field"
              :disabled="field.disabled || savingPatient || disableComponents"
              :mask="field.mask"
            />
          </div>
        </b-form-group>
      </b-form>
      <template #modal-footer="{ ok, cancel }">
        <div class="buttons" :class="$mq">
          <b-button
            variant="secondary"
            @click="cancel()"
            :disabled="savingPatient || disableComponents"
          >
            {{ $t('buttons.cancel') }}
          </b-button>
          <b-button
            variant="info"
            @click="ok()"
            :disabled="savingPatient || disableComponents"
          >
            <Spinner v-if="savingPatient" size="small" />
            <span v-else>
              {{ $t('buttons.save') }}
            </span>
          </b-button>
        </div>
      </template>
    </b-modal>
  </Modal>
</template>

<script>
import Modal from '@/components/home/Modal';
import FormField from '@/components/utils/FormField';
import Spinner from '@/components/utils/Spinner';
import Skeleton from '@/components/utils/Skeleton';

import patient_model from '@/models/patient';

import api from '@/mixins/api';
import helper from '@/mixins/helper';
import validate from '@/mixins/validate';

import { mapState } from 'vuex';
import axios from 'axios';

export default {
  components: { Modal, FormField, Spinner, Skeleton },

  mixins: [patient_model, api, helper, validate],

  props: { wait: Boolean },

  data() {
    return {
      disableComponents: false,
      loadingPatient: false,
      savingPatient: false,
      patientData: {},
    };
  },

  computed: mapState(['customer', 'patient']),

  methods: {
    init() {
      this.loadingPatient = true;
      this.disableComponents = true;

      this.patient_model.fields.form.forEach(group =>
        group.fields.forEach(field => {
          field.state = true;
        }),
      );

      this.patientData = { ...this.patient };
    },

    reset() {
      this.$store.commit('mutate', { prop: 'patient', with: {} });
    },

    confirm(bvModalEvt) {
      bvModalEvt.preventDefault();

      let fieldsValidity = true;
      this.patient_model.fields.form.forEach(group => {
        if (!this.checkFieldsValidity(this.patient, group.fields)) {
          fieldsValidity = false;
        }
      });

      if (fieldsValidity) {
        this.savePatient();
      }
    },

    async savePatient() {
      this.savingPatient = true;

      const patient = {
        ...this.patient,
        customer_id: this.customer.id,
      };

      this.patient_model.fields.form.forEach(group => {
        group.fields.forEach(field => {
          if (field.formatter) {
            patient[field.key] = this[field.formatter](this.patient[field.key]);
          }
        });
      });

      await axios
        .put(`${this.baseApiUrl}/patients_merge/${patient.id}`, patient)
        .then(async () => {
          this.$toasted.global.defaultSuccess({
            msg: this.$t('messages.patient.confirmed', {
              title: patient[this.patient_model.mainField],
              operation: this.$t('messages.patient.updated'),
            }),
          });

          if (this.wait) {
            await this.$emit('wait');
          }

          this.$emit('submit');
          this.$bvModal.hide('appointments-patient-modal');
        })
        .catch(this.showError);

      this.savingPatient = false;
    },
  },

  watch: {
    patient(obj) {
      if (obj.id) {
        this.loadingPatient = false;
        this.disableComponents = false;
      }
    },
  },
};
</script>

<style>
#appointments-patient-modal___BV_modal_content_ {
  margin: -30px 0 0 -10px;
}
</style>
